export const verificationListData = [
  {
    title: "Your mobile",
    subTitle: "Uploading documents will be done on your mobile phone",
    icon: "mobile",
  },
  {
    title: "Documents",
    subTitle: (
      <>
        1 x photo ID (a passport or driver’s licence)
        <br />
        Bank statement
      </>
    ),
    icon: "document",
  },
  {
    title: "A well lit space",
    subTitle:
      "The best chance to get a clear image of yourself and your documents",
    icon: "well-lit",
  },
];
